import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourceModalWrapper = styled(motion.div)`
  max-height: calc(100svh - (var(--navbar-height) * 2));

  position: fixed;
  top: var(--navbar-height);
  left: 0px;
  right: 0px;

  display: flex;
  justify-content: center;

  z-index: 99999999;

  padding: 0px 16px;

  border-radius: 30px;

  ${BREAKPOINTS.tablet} {
    top: 16px;
    max-height: calc(100svh - 32px);
  }
`;

interface ResourceModalContainerProps {
  showingWarning: boolean;
}

export const ResourceModalContainer = styled(motion.div)<ResourceModalContainerProps>`
  width: 100%;
  max-height: 100%;
  max-width: 1440px;

  border-radius: 30px !important;
  background: linear-gradient(0deg, #f7f7f7 77.65%, #e2e6ee 88.12%, #d4dae8 95.57%, #7684a2 100%);
  box-shadow: 0 6px 24px 0 rgba(0, 0, 0, 0.1);

  position: relative;

  overflow-y: auto;

  ${({ showingWarning }) =>
    showingWarning
      ? `
    filter: blur(5px);
    pointer-events: none;
    user-select: none;
  `
      : null};
`;

export const ResourceModalCloseIcon = styled.div`
  width: 30px;
  height: 30px;

  position: absolute;
  top: 28px;
  right: 21px;

  display: flex;
  flex-direction: column;

  cursor: pointer;
  z-index: 1002;

  ${BREAKPOINTS.tablet} {
    position: fixed;
  }
`;

export const ResourceModalContent = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  padding: 78px 28px;

  position: relative;

  ${BREAKPOINTS.tablet} {
    padding: 58px 16px 16px 16px;
  }
`;
